import { MeetingArrivalsComponent } from './meeting-rooms/meeting-arrivals/meeting-arrivals.component';
import { BilledRevenueLineComponent } from './revenue-total/billed-revenue-line/billed-revenue-line.component';
import { EarnedRevenueLineComponent } from './revenue-total/earned-revenue-line/earned-revenue-line.component';
import { BilledRevenueDonutComponent } from './revenue-by-category/billed-revenue-donut/billed-revenue-donut.component';
import { EarnedRevenueDonutComponent } from './revenue-by-category/earned-revenue-donut/earned-revenue-donut.component';
import { FixedChargesByCategoryComponent } from './fixed-charges/fixed-charges-by-category/fixed-charges-by-category.component';
import { MeetingRoomUtilizationComponent } from './meeting-rooms/meeting-room-utilization/meeting-room-utilization.component';
import { CheckInsComponent } from './check-ins/check-ins/check-ins.component';
import { MonthlyCheckInsComponent } from './check-ins/monthly-check-ins/monthly-check-ins.component';
import { DayOfWeekCheckInsComponent } from './check-ins/day-of-week-check-ins/day-of-week-check-ins.component';
import { MeetingRoomRequirementsComponent } from './meeting-rooms/meeting-room-requirements/meeting-room-requirements.component';
import { TodoComponent } from './todo/todo.component';
import { TwoMonthCompareComponent } from './revenue-by-category/two-month-compare/two-month-compare.component';
import { MailForwardingComponent } from './mail-forwarding/mail-forwarding.component';

export class DashboardComponents {
  static components = {
    BilledRevenueByCategory: BilledRevenueDonutComponent,
    BilledRevenueTotal: BilledRevenueLineComponent,
    EarnedRevenueByCategory: EarnedRevenueDonutComponent,
    EarnedRevenueTotal: EarnedRevenueLineComponent,
    FixedChargesByCategory: FixedChargesByCategoryComponent,
    MailForwarding: MailForwardingComponent,
    MeetingRoomUtilization: MeetingRoomUtilizationComponent,
    CheckIns: CheckInsComponent,
    DayOfWeekCheckIns: DayOfWeekCheckInsComponent,
    MonthlyCheckIns: MonthlyCheckInsComponent,
    MeetingRoomRequirements: MeetingRoomRequirementsComponent,
    MeetingArrivals: MeetingArrivalsComponent,
    Todo: TodoComponent,
    TwoMonthCompare: TwoMonthCompareComponent
  }
}
